import { Controller, FieldError, useFormContext } from "react-hook-form";
import { mdiDeleteOutline, mdiPlusCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";

import Select from "components/Select";
import { FR_LINE_TYPE_LIST } from "constants/haulpay-broker";
import { useUserFeature } from "hooks/useUserFeature";
import { IFundingRequest, IFundingRequestForm } from "models/HaulPay";
import styles from "./style.module.scss";
import DollarInput from "components/DollarInput";

interface IFRLineItemsProps {
  onChangeLineItemAmount: (amount: number) => void;
}

export default function FRLineItems({ onChangeLineItemAmount }: Readonly<IFRLineItemsProps>) {
  const {
    control,
    formState: { errors },
    getValues,
    watch,
    setValue
  } = useFormContext<IFundingRequestForm | IFundingRequest>();
  const { isAllowLineItems } = useUserFeature();
  const lineItems = watch("lineItems");

  const addLocation = () => {
    setValue("lineItems", [...lineItems, { amount: "" as any, category: FR_LINE_TYPE_LIST[1] }]);
  };

  const removeLocation = (index: number) => {
    setValue(
      "lineItems",
      lineItems.filter((_, i) => i !== index)
    );
  };

  const onChangeAmount = (amount?: string, index?: number) => {
    let totalAmount = 0;
    const items = getValues("lineItems");
    items.forEach((item, i) => {
      if (index !== i) {
        totalAmount += item.amount ? Number(item.amount) : 0;
      }
    });
    onChangeLineItemAmount(totalAmount + Number(amount ?? 0));
  };

  return isAllowLineItems ? (
    <ul className={styles.frLineItemsContainer}>
      {lineItems?.map((item, index) => (
        <li key={lineItems.length + index} className="flex flex-col gap-2">
          <div className={styles.list}>
            <DollarInput
              name={`lineItems.${index}.amount`}
              label="&nbsp;Amount"
              error={errors.lineItems?.[index]?.amount as FieldError}
              isHideError
              className="flex-1"
              onChange={(e) => {
                onChangeAmount(e.currentTarget.value, index);
              }}
            />
            <Controller
              name={`lineItems.${index}.category`}
              control={control}
              render={({ field: { value = item.category, onChange } }) => {
                return (
                  <Select
                    value={value}
                    options={FR_LINE_TYPE_LIST}
                    error={errors.lineItems?.[index]?.category as FieldError}
                    onChange={onChange}
                    label="&nbsp;Type"
                    className="w-1/3"
                  />
                );
              }}
            />
            <button
              type="button"
              className={styles.deleteButton}
              onClick={() => {
                removeLocation(index);
                onChangeAmount();
              }}>
              <Icon path={mdiDeleteOutline} />
            </button>
          </div>

          <span className="px-2 text-sm text-error">
            {errors.lineItems?.[index]?.amount?.message}
          </span>
        </li>
      ))}

      <div className="flex justify-between">
        <button type="button" onClick={addLocation}>
          <span className="text-info">+ Add Another Charge</span>
        </button>
        <button type="button" onClick={addLocation}>
          <Icon path={mdiPlusCircleOutline} className="size-6" />
        </button>
      </div>
    </ul>
  ) : null;
}
